import { Accordion, AccordionTab } from "primereact/accordion";
import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";

import chassis from "../../assets/images/icons/vehicle-card-chassis.svg";
import color from "../../assets/images/icons/vehicle-card-color.svg";
import seat from "../../assets/images/icons/vehicle-card-seats.svg";
import transnission from "../../assets/images/icons/vehicle-card-transmission.svg";
import vehicle from "../../assets/images/icons/vehicle.svg";
import VehicleInfoWrapper from "./VehicleInfo.style";
// import registry from "../../assets/images/icons/vehicle-card-calendar.svg";
import { Dropdown } from "primereact/dropdown";
import propTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { renewalActions } from "../../redux/actions";
import * as renewalService from "../../services/renewal-service";

const VehicleInfo = (props) => {
  // const border = {
  //   border: "none",
  // };

  const { expand = true } = props;
  const dispatch = useDispatch();
  const [colorlist, setColorlist] = useState([]);
  const [colorCodeValue, setColorCodeValue] = useState({});
  const { renewalCarColor } = useSelector((state) => state.renewal);

  useEffect(() => {
    TriggerColorApi();
  }, []);

  useEffect(() => {
    if (renewalCarColor?.colorCode?.length < 0) {
      TriggerColorApi();
    }
  }, [props.i18n.language]);
  useEffect(() => {
    if (colorlist?.length > 0 && props.quotationData?.color?.length > 0) {
      const colors = colorlist.find(
        (ele) => ele.colorCode == props.quotationData.vehicleDetails.colorCode
      );
      setColorCodeValue(colors.colorCode);
    }
  }, [colorlist]);

  const TriggerColorApi = async () => {
    const request = {
      languageCode: props.i18n.language?.slice(0, 1)?.toUpperCase(),
      colorCode: "",
      channelDetails: {
        applicationCategory: "RH",
        branchCode: "1",

        applicationType: "RHSP",
        userName: "EBUSUSER",
        channelCode: "85",
      },
    };
    renewalService.getMotorColor(request).then((res) => {
      const whiteList = [
        {
          colorCode: "17",
          colorDescription: "أبيض",
        },
      ];
      
      try {
        setColorlist(res?.data?.detailsArray ?? whiteList);
      } catch {
        setColorlist(whiteList);
      }
    });
  };

  const handleChangeColourChange = (valueHold) => {
    const colors = colorlist.find((ele) => ele.colorCode == valueHold);
    setColorCodeValue(colors);
    dispatch(renewalActions.setUpdateColor(colors));
  };

  return (
    <VehicleInfoWrapper>
      <div
        className={
          "vehicle-wrapper " + (props.i18n.language === "ar" ? "ar" : "")
        }
      >
        <div className="vehicle-info-wrapper">
          <div className="container">
            <div
              className="row"
              style={{ alignItems: "flex-start", border: "2px soild black" }}
            >
              <div className="col-md-3" style={{ textAlign: "initial" }}>
                <div className="text-wrapper">
                  <p>{props.i18n.t("POLICY.MY_VEHICLE")}</p>
                </div>
              </div>
              <div className="col-md-9">
                <div className="row">
                  <div className="col-3 my-auto">
                    <img
                      className="accord-img"
                      src={vehicle}
                      alt="Vehicle Logo"
                    />
                  </div>
                  <div className="col-9">
                    <div className="head-wrapper lato">
                      <p className="lato">{props.quotationData.carTitle}</p>
                    </div>
                    <div className="bottom-wrapper ">
                      <p>
                        <span className="mx-1">
                          {props.i18n.t("POLICY.PLATE_NUMBER")}{" "}
                        </span>
                        <span dir="ltr" className="lato mx-1">
                          {props.quotationData.plateNumber}
                        </span>
                        <span dir="rtl">
                          {props.quotationData.plateNumberCharchters}
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="vel-wrapper-mobile">
          <div className="container">
            <div className="row">
              <div className="col-3 accord-class">
                <img className="accord-img" src={vehicle} alt="Vehicle Logo" />
              </div>

              <div className="col-9  accord-text">
                <div className="head-wrapper">
                  <p>{props.quotationData.carTitle}</p>
                </div>
                <div className="bottom-wrapper">
                  <p>
                    {props.i18n.t("plateNumber")}{" "}
                    {props.quotationData.plateNumber}{" "}
                    <span>{props.quotationData.plateNumberCharchters}</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </VehicleInfoWrapper>
  );
};

VehicleInfo.propTypes = propTypes.exact({
  quotationData: propTypes.any,
}).isRequired;

export default withTranslation()(VehicleInfo);
